import { reactive, computed } from 'vue'

const PLANS = [
    {
        id: 'starter',
        name: 'Starter',
        color: '#6366F1',
        monthlyPrice: 99,
        yearlyPrice: 948,
        features: [
            { text: '3 Kullanıcı', included: true },
            { text: '5GB Depolama', included: true },
            { text: 'Temel Modüller', included: true },
            { text: 'E-posta Destek', included: true },
            { text: 'API Erişimi', included: false },
            { text: 'Entegrasyonlar', included: false },
        ],
    },
    {
        id: 'pro',
        name: 'Pro',
        color: '#10B981',
        popular: true,
        monthlyPrice: 299,
        yearlyPrice: 2868,
        features: [
            { text: '10 Kullanıcı', included: true },
            { text: '50GB Depolama', included: true },
            { text: 'Tüm Modüller', included: true },
            { text: 'Öncelikli Destek', included: true },
            { text: 'API Erişimi', included: true },
            { text: 'Entegrasyonlar', included: false },
        ],
    },
    {
        id: 'enterprise',
        name: 'Enterprise',
        color: '#F59E0B',
        monthlyPrice: 599,
        yearlyPrice: 5748,
        features: [
            { text: 'Sınırsız Kullanıcı', included: true },
            { text: '500GB Depolama', included: true },
            { text: 'Tüm Modüller', included: true },
            { text: '7/24 Destek', included: true },
            { text: 'API Erişimi', included: true },
            { text: 'Entegrasyonlar', included: true },
        ],
    },
]

const MODULES = [
    { id: 1, name: 'İş Emri', description: 'Araç bakım ve onarım süreçlerini yönetin', icon: 'workorder', color: '#0EA5E9', price: 0, owned: true },
    { id: 2, name: 'Notlar', description: 'Ekip içi notlar ve paylaşımlar', icon: 'note', color: '#F59E0B', price: 0, owned: true },
    { id: 3, name: 'Ajanda', description: 'Takvim ve etkinlik yönetimi', icon: 'agenda', color: '#EF4444', price: 0, owned: true },
    { id: 4, name: 'Analitik', description: 'Detaylı raporlama ve analiz', icon: 'analytics', color: '#8B5CF6', price: 59, owned: false },
    { id: 5, name: 'Muhasebe', description: 'Gelir gider takibi ve finansal raporlar', icon: 'accounting', color: '#10B981', price: 79, owned: false },
    { id: 6, name: 'SMS', description: 'Toplu ve bireysel SMS gönderimi', icon: 'sms', color: '#EC4899', price: 39, owned: false },
    { id: 7, name: 'Stok Yönetimi', description: 'Depo ve envanter takibi', icon: 'stock', color: '#F97316', price: 49, owned: true },
    { id: 8, name: 'E-Fatura', description: 'Elektronik fatura kesimi ve takibi', icon: 'invoice', color: '#14B8A6', price: 89, owned: false },
]

const ORDERS = [
    { id: 1042, type: 'plan', name: 'Pro Plan Yıllık', date: '2026-03-05', amount: 2581, status: 'completed', paymentMethod: 'Visa **** 4242' },
    { id: 1038, type: 'module', name: 'SMS Modülü', date: '2026-02-28', amount: 39, status: 'completed', paymentMethod: 'Visa **** 4242' },
    { id: 1035, type: 'wallet', name: 'Bakiye Yükleme', date: '2026-02-20', amount: 500, status: 'failed', paymentMethod: 'Visa **** 4242' },
    { id: 1029, type: 'plan', name: 'Enterprise Plan', date: '2026-02-15', amount: 599, status: 'cancelled', paymentMethod: 'MC **** 8888' },
    { id: 1025, type: 'module', name: 'Analitik Modülü', date: '2026-02-10', amount: 59, status: 'completed', paymentMethod: 'Visa **** 4242' },
    { id: 1018, type: 'wallet', name: 'Bakiye Yükleme', date: '2026-01-25', amount: 1000, status: 'completed', paymentMethod: 'MC **** 8888' },
    { id: 1012, type: 'plan', name: 'Pro Plan Aylık', date: '2026-01-05', amount: 299, status: 'completed', paymentMethod: 'Visa **** 4242' },
]

const TRANSACTIONS = {
    1035: [
        { id: 'TX-001', date: '2026-02-20 14:32', method: 'Visa **** 4242', amount: 500, status: 'failed', error: 'Yetersiz bakiye' },
        { id: 'TX-002', date: '2026-02-20 14:35', method: 'Visa **** 4242', amount: 500, status: 'failed', error: 'Kart reddedildi' },
    ],
    1042: [
        { id: 'TX-003', date: '2026-03-05 09:15', method: 'Visa **** 4242', amount: 2581, status: 'completed', error: null },
    ],
}

const WALLET_HISTORY = [
    { id: 1, type: 'topup', description: 'Bakiye Yükleme', date: '2026-03-05', amount: 500 },
    { id: 2, type: 'payment', description: 'Pro Plan Ödemesi', date: '2026-03-01', amount: -299 },
    { id: 3, type: 'topup', description: 'Bakiye Yükleme', date: '2026-02-15', amount: 1000 },
    { id: 4, type: 'refund', description: 'İade - Analitik Modülü', date: '2026-02-10', amount: 49 },
    { id: 5, type: 'payment', description: 'SMS Modülü Ödemesi', date: '2026-01-28', amount: -39 },
    { id: 6, type: 'topup', description: 'Bakiye Yükleme', date: '2026-01-15', amount: 250 },
]

const CARDS = reactive([
    { id: 1, brand: 'visa', number: '4242', expiry: '12/27', holder: 'BERKAY YILDIZ', isDefault: true },
    { id: 2, brand: 'mastercard', number: '8888', expiry: '03/28', holder: 'BERKAY YILDIZ', isDefault: false },
])

const ADDRESSES = reactive([
    { id: 1, label: 'İş Adresi', line: 'Barbaros Mah. Begonya Sok. No:15', district: 'Ataşehir', city: 'İstanbul', isDefault: true },
    { id: 2, label: 'Fatura Adresi', line: 'Caferağa Mah. Moda Cad. No:42', district: 'Kadıköy', city: 'İstanbul', isDefault: false },
])

const DISCOUNT_CODES = {
    'HOSGELDIN':  { type: 'percent', value: 15, label: 'Hoş Geldin İndirimi' },
    'INDIRIM10':  { type: 'percent', value: 10, label: '%10 İndirim' },
    'INDIRIM20':  { type: 'percent', value: 20, label: '%20 İndirim' },
    'YILSONU':    { type: 'percent', value: 30, label: 'Yıl Sonu Kampanyası' },
    'SABIT50':    { type: 'fixed', value: 50, label: '50₺ İndirim' },
    'SABIT100':   { type: 'fixed', value: 100, label: '100₺ İndirim' },
}

const state = reactive({
    activePlanIds: ['pro', 'starter'],
    billingPeriod: 'yearly',
    planExpiryDate: '2026-04-05',
    walletBalance: 1250,
    activeSection: 'packages',
    selectedOrderId: null,
    checkoutOpen: false,
    checkoutItem: null,
    checkoutStep: 1,
    checkoutAddressId: 1,
    checkoutPaymentMethod: 'card',
    checkoutCardId: 1,
    checkoutNewCard: { number: '', expiry: '', cvv: '', holder: '' },
    checkoutDiscount: null,
    checkoutDiscountError: false,
    checkoutAgreed: false,
    paymentStatus: null,
    paymentError: null,
    paymentOrderId: null,
    externalPaymentResult: null,
    addCardOpen: false,
    addAddressOpen: false,
    topupOpen: false,
    topupAmount: null,
    moduleFilter: 'all',
})

const activePlans = computed(() => PLANS.filter(p => state.activePlanIds.includes(p.id)))
const primaryPlan = computed(() => activePlans.value[0] || null)
const selectedOrder = computed(() => ORDERS.find(o => o.id === state.selectedOrderId))
const selectedTransactions = computed(() => TRANSACTIONS[state.selectedOrderId] || [])

function isPlanActive(planId) {
    return state.activePlanIds.includes(planId)
}

function setSection(section) {
    state.activeSection = section
    state.selectedOrderId = null
}

function selectOrder(id) {
    state.selectedOrderId = id
    state.activeSection = 'orderDetail'
}

function backToOrders() {
    state.selectedOrderId = null
    state.activeSection = 'orders'
}

function setBillingPeriod(period) {
    state.billingPeriod = period
}

function setModuleFilter(filter) {
    state.moduleFilter = filter
}

function openCheckout(item) {
    state.checkoutItem = item
    state.checkoutStep = 1
    state.checkoutAddressId = ADDRESSES.find(a => a.isDefault)?.id || ADDRESSES[0]?.id || 1
    state.checkoutPaymentMethod = 'card'
    state.checkoutCardId = CARDS.find(c => c.isDefault)?.id || CARDS[0]?.id || 1
    state.checkoutNewCard = { number: '', expiry: '', cvv: '', holder: '' }
    state.checkoutDiscount = null
    state.checkoutDiscountError = false
    state.checkoutAgreed = false
    state.paymentStatus = null
    state.paymentError = null
    state.paymentOrderId = null
    state.addAddressOpen = false
    state.checkoutOpen = true
}

function closeCheckout() {
    state.checkoutOpen = false
    state.checkoutItem = null
    state.addAddressOpen = false
}

function nextStep() {
    if (state.checkoutStep < 3) state.checkoutStep++
}

function prevStep() {
    if (state.checkoutStep > 1) state.checkoutStep--
}

function processPayment() {
    state.checkoutStep = 4
    state.paymentStatus = 'processing'
    state.paymentError = null
    setTimeout(() => {
        if (Math.random() < 0.7) {
            state.paymentStatus = 'success'
            state.paymentOrderId = 1043 + Math.floor(Math.random() * 100)
        } else {
            state.paymentStatus = 'failed'
            state.paymentError = 'Ödeme işlemi sırasında bir hata oluştu. Lütfen tekrar deneyin.'
        }
    }, 1800)
}

function retryPayment() {
    state.checkoutStep = 2
    state.paymentStatus = null
    state.paymentError = null
    state.paymentOrderId = null
}

function showExternalPaymentResult(result) {
    state.externalPaymentResult = result
}

function clearExternalPaymentResult() {
    state.externalPaymentResult = null
}

function applyDiscount(code) {
    if (!code || !code.trim()) {
        state.checkoutDiscountError = false
        return false
    }
    const upper = code.trim().toUpperCase()
    const discount = DISCOUNT_CODES[upper]
    if (discount) {
        state.checkoutDiscount = { code: upper, ...discount }
        state.checkoutDiscountError = false
        return true
    }
    state.checkoutDiscountError = true
    state.checkoutDiscount = null
    return false
}

function clearDiscount() {
    state.checkoutDiscount = null
    state.checkoutDiscountError = false
}

function addAddress(addr) {
    const newId = ADDRESSES.length ? Math.max(...ADDRESSES.map(a => a.id)) + 1 : 1
    ADDRESSES.push({ id: newId, ...addr, isDefault: false })
    state.checkoutAddressId = newId
    state.addAddressOpen = false
}

function toggleAddAddress() {
    state.addAddressOpen = !state.addAddressOpen
}

function toggleTopup() {
    state.topupOpen = !state.topupOpen
    if (!state.topupOpen) state.topupAmount = null
}

function setTopupAmount(amount) {
    state.topupAmount = amount
}

function toggleAddCard() {
    state.addCardOpen = !state.addCardOpen
}

function setDefaultCard(id) {
    CARDS.forEach(c => { c.isDefault = c.id === id })
}

function formatPrice(amount) {
    return new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(amount)
}

function formatDate(dateStr) {
    const d = new Date(dateStr)
    const months = ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara']
    return d.getDate() + ' ' + months[d.getMonth()] + ' ' + d.getFullYear()
}

export default {
    state,
    PLANS,
    MODULES,
    ORDERS,
    TRANSACTIONS,
    WALLET_HISTORY,
    CARDS,
    ADDRESSES,
    DISCOUNT_CODES,
    activePlans,
    primaryPlan,
    selectedOrder,
    selectedTransactions,
    isPlanActive,
    setSection,
    selectOrder,
    backToOrders,
    setBillingPeriod,
    setModuleFilter,
    openCheckout,
    closeCheckout,
    nextStep,
    prevStep,
    processPayment,
    retryPayment,
    showExternalPaymentResult,
    clearExternalPaymentResult,
    applyDiscount,
    clearDiscount,
    addAddress,
    toggleAddAddress,
    toggleTopup,
    setTopupAmount,
    toggleAddCard,
    setDefaultCard,
    formatPrice,
    formatDate,
}
